<template>
  <el-drawer
    :append-to-body="true"
    :title="titleValue"
    :visible.sync="newCodeDialog"
    custom-class="drawerClass"
    direction="ltr"
    size="520px"
    @close="handleNewCodeDialog"
  >
    <div style="padding: 0 20px">
      <el-form
        ref="addFormRef"
        :inline="false"
        :model="addForm"
        :rules="rules"
        class="search-form"
        label-position="top"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <!--      上岗日期      -->
            <el-form-item :label="$t('home.onDutyDate')" prop="workDate" style="width: 100%">
              <el-date-picker
                v-model="addForm.workDate"
                :picker-options="pickerOptions"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                style="width: 100%"
                type="date"
                value-format="yyyy-MM-dd"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!-- 选择岗位 -->
            <el-form-item :label="$t('home.selectPosition')" prop="position">
              <el-select
                v-model="addForm.position"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                collapse-tags
                filterable
                style="width: 100%"
                @change="handlePosition"
              >
                <el-option
                  v-for="item in positionList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col v-if="addForm.position === 2" :span="24">
            <!--转运中心-->
            <el-form-item :label="$t('collectionCenter.transferCenter')" prop="departmentId">
              <el-select
                v-model="addForm.departmentId"
                :placeholder="$t('GlobalSetObj.pleaseChoose')"
                clearable
                collapse-tags
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="item in TransferList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <!-- 上岗人数 -->
            <el-form-item :label="$t('home.onDutyCount')" prop="staffCount" style="width: 100%">
              <el-input
                v-model.number="addForm.staffCount"
                :placeholder="$t('userManage.pleaseInput')"
                clearable
                maxlength="5"
                show-word-limit
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <div style="float: right">
              <!-- 确定 -->
              <el-button
                size="small" type="primary" @click="submitForm"
              >{{ $t('GlobalSetObj.determine') }}
              </el-button>
              <!--  取消 -->
              <el-button
                size="small" @click="handleNewCodeDialog"
              >{{ $t('GlobalSetObj.cancel') }}
              </el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </el-drawer>
</template>

<script>
import { apiStaffRegistrationAdd, apiStaffRegistrationEdit } from '@/api/newExpressAPI/userModule'; // 校验函数：确保输入为数字
// 校验函数：确保输入为数字
export default {
  props: {
    positionList: {
      type: Array,
      default: () => []
    },
    TransferList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      newCodeDialog: false,
      timeValue: [],
      addForm: {
        departmentId: '', // 转运中心ID
        staffCount: '', // 上岗人数
        position: '', // 派送车辆类型(看需求)
        workDate: '' // 上岗日期
      },
      rules: {
        departmentId: [
          { required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: 'change' }
        ],
        staffCount: [
          { required: true, message: this.$t('GlobalSetObj.pleaseInput'), trigger: 'change' },
          {
            validator: (rule, value, callback) => {
              // 校验规则：只能包含数字（0-9）
              const regex = /^\d+$/;
              if (regex.test(value)) {
                // 是数字，校验通过
                callback();
              } else {
                // 不是数字，返回错误信息
                callback(new Error(this.$t('home.enterValidNumber')));
              }
            },
            trigger: ['blur', 'change']
          }
        ],
        position: [
          { required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: 'blur' }
        ],
        workDate: [
          { required: true, message: this.$t('GlobalSetObj.pleaseChoose'), trigger: 'blur' }
        ]
      },
      titleValue: this.$t('GlobalSetObj.add'),
      pickerOptions: {
        disabledDate(time) {
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          return time.getTime() < today.getTime();
        }
      }
    };
  },
  methods: {
    submitForm() {
      this.$refs['addFormRef'].validate(async(valid) => {
        if (valid) {
          if (this.addForm.id) {
            const res = await apiStaffRegistrationEdit(this.addForm);
            if (res.code === 200) {
              this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
            }
          } else {
            const res = await apiStaffRegistrationAdd(this.addForm);
            if (res.code === 200) {
              this.$message.success(this.$t('GlobalSetObj.TheOperationSucceeded'));
            }
          }
          this.handleNewCodeDialog();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    handlePosition(val) {
      if (val !== 2) {
        this.addForm.departmentId = '';
      }
    },
    // 控制弹框
    openCodeDialog(row) {
      if (row.id) {
        this.titleValue = this.$t('trajectory.modify');
        this.addForm = row;
      } else {
        this.titleValue = this.$t('GlobalSetObj.add');
        this.addForm = {
          departmentId: '', // 转运中心ID
          staffCount: '', // 上岗人数
          position: '', // 派送车辆类型(看需求)
          workDate: '' // 上岗日期
        };
      }
      console.log(this.addForm, 'openCodeDialog');
      this.newCodeDialog = true;
    },
    handleNewCodeDialog() {
      this.$emit('invoke-search');
      this.$refs['addFormRef'].resetFields();
      this.newCodeDialog = false;
    }
  }
};
</script>

<style scoped></style>
